// GENERATED FILE - DO NOT MODIFY

export enum GetInvoicesSortColumnDto {
    Number = "Number",
    Description = "Description",
    IssueDate = "IssueDate",
    Total = "Total",
    LocationName = "LocationName",
}